import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=2022e1d2&"
import script from "./Calculation.vue?vue&type=script&lang=ts&"
export * from "./Calculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports